import { render, staticRenderFns } from "./buy-crypto.vue?vue&type=template&id=fe540e82&lang=pug"
import script from "./buy-crypto.vue?vue&type=script&lang=js"
export * from "./buy-crypto.vue?vue&type=script&lang=js"
import style0 from "./buy-crypto.vue?vue&type=style&index=0&id=fe540e82&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports